import { render, staticRenderFns } from "./FinalScreen.vue?vue&type=template&id=834c651a&"
import script from "./FinalScreen.vue?vue&type=script&lang=js&"
export * from "./FinalScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports